import { useEffect, useState, useRef, RefObject } from 'react';
import { FaCaretRight } from 'react-icons/fa';
import Form from '../../Form';
import {
  InputData,
  initialInputData,
  inputDataConfig,
} from './inputData';
import {
  Wrapper,
  Title,
  ProgressWrapper,
  Progress,
  ProgressArrow,
  Desc,
  FormWrapper,
  Button
} from "./style"
import {API_URL} from '../../../const'

const Input = () => {
  const params = (new URL(window.location.href)).searchParams;
  const emailEncoded: string|null = params.get("email")
  
  const [inputData, setInputData] = useState<InputData>(initialInputData)
  const refs:{[key:string]: RefObject<HTMLDivElement>} = {
    userCode: useRef<HTMLDivElement>(null),
    lastName: useRef<HTMLDivElement>(null),
    firstName: useRef<HTMLDivElement>(null),
    lastNameKana: useRef<HTMLDivElement>(null),
    firstNameKana: useRef<HTMLDivElement>(null),
    tel: useRef<HTMLDivElement>(null),
    email: useRef<HTMLDivElement>(null),
  }
  const [errors, setErrors] = useState<{[key: string]: boolean}>({
    userCode: false,
    lastName: false,
    firstName: false,
    lastNameKana: false,
    firstNameKana: false,
    tel: false,
    email: false,
  })
  const isValid = () => {
    const keys = Object.keys(inputDataConfig)    
    const len = keys.length
    let didScroll = false
    let allMsg = ""
    let newErrors: {[key: string]: boolean} = {}
    for (let i=0;i<len;i++) {
      const key = keys[i]
      const config = inputDataConfig[key]
      newErrors[key] = false
      if (config.required && !inputData[key]) {
        const msg = "・「" + config.name + "」を入力してください。"
        allMsg += msg + "\n"
        if (!didScroll) {
          refs[key].current?.scrollIntoView();
          didScroll = true
        }
        newErrors[key] = true
        continue
      }
      if (config.pattern && !config.pattern.test(inputData[key])) {
        const msg = "・「" + config.name + "」の内容が適切ではありません。もう一度入力内容をご確認ください。"
        allMsg += msg + "\n"
        if (!didScroll) {
          refs[key].current?.scrollIntoView();
          didScroll = true
        }
        newErrors[key] = true
        continue
      }
    }
    setErrors(newErrors)
    if (allMsg) {
      alert("以下の入力項目を修正してください。\n" + allMsg)
      return false
    } else {
      return true
    }
  }

  const isInput = (checkData: InputData) => {
    const keys = Object.keys(checkData)    
    const len = keys.length
    for (let i=0;i<len;i++) {
      const data = checkData[keys[i]]
      if (!data) continue
      return true
    }
    return false
  }

  useEffect(() => {
    if (!emailEncoded) {
      window.location.href = "/token-error"
      return
    }
    (async () => {
      console.log("emailEncoded")
      console.log(emailEncoded)
      const email = atob(emailEncoded)
      console.log("email")
      console.log(email)
      setInputData({...inputData, email: email})
    })()
  }, [])

  return (
    <Wrapper>
      <Title>
        memart 本登録フォーム
      </Title>
      <ProgressWrapper>
        <Progress>① 利用規約確認</Progress>
        <ProgressArrow><FaCaretRight/></ProgressArrow>
        <Progress active>② 情報入力</Progress>
        <ProgressArrow><FaCaretRight/></ProgressArrow>
        <Progress>③ 完了</Progress>
      </ProgressWrapper>
      <Desc>
        MEMにご登録されている情報を入力してください。
      </Desc>
      <FormWrapper>
        {Object.keys(inputDataConfig).map((key) => {
          const config = inputDataConfig[key]
          return (
          <Form
            ref={refs[key]}
            title={config.name}
            type={config.type}
            value={inputData[key]}
            caution={config.caution}
            placeholder={config.placeholder}
            required={config.required}
            options={config.options}
            error={errors[key]}
            onChange={(e) => {
              setInputData({...inputData, [key]: e.target.value})
              console.log("save: ")
              console.log(JSON.stringify({...inputData, [key]: e.target.value}))
              localStorage.setItem('inputData', JSON.stringify({...inputData, [key]: e.target.value}))
            }}
          />
          )
        })}
      </FormWrapper>
      <Button onClick={async () => {
        if (!isValid()) {
          return
        }
        if (!window.confirm ('入力した内容で本登録しますか？')) return
        const res = await fetch (API_URL + "ec/auth", {
          method: 'POST',
          cache: 'no-cache',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(inputData)
        })
        const status = res.status
        if (status !== 200) {
          const resData = await res.json()
          alert(resData.msg) 
          console.log(resData)
          return
        } 
        window.location.href = '/ec-done'
      }}>
        本登録する
      </Button>
    </Wrapper>
  )
}
export default Input;
